import { render, staticRenderFns } from "./GerbangTolDetail.vue?vue&type=template&id=2d504c89&scoped=true"
import script from "./GerbangTolDetail.vue?vue&type=script&lang=js"
export * from "./GerbangTolDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d504c89",
  null
  
)

export default component.exports